import React, { useEffect } from 'react';
import { useLanguage } from '../context/LanguageContext';
import { useTenant } from '../context/TenantContext';
import { ListIcon } from '../components/icons';
import DOMPurify from 'dompurify';

const TermsAndConditions = () => {
  const { t } = useLanguage();
  const { tenant } = useTenant();

  // Add CSS for links in Terms content
  useEffect(() => {
    const style = document.createElement('style');
    style.innerHTML = `
      .terms-content a {
        color: #2563eb !important;
        text-decoration: underline !important;
        cursor: pointer !important;
      }
      .terms-content a:hover {
        color: #1d4ed8 !important;
      }
    `;
    document.head.appendChild(style);
    return () => document.head.removeChild(style);
  }, []);



  return (
    <div className="max-w-5xl mx-auto p-4 md:px-4 space-y-6 mt-8">
      {/* Header */}
      <div className="flex items-center gap-3 mb-6">
        <ListIcon className="w-4 h-4 text-theme-primary" />
        <h1 className="text-base font-extrabold text-theme-secondary">
          {tenant?.termsandconditionsdisplay || t('terms.title') || 'Terms and Conditions'}
        </h1>
      </div>

      {/* Content */}
      <div className="text-gray-700">
        <div 
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(tenant?.tenanttermsandconditions || ''),
          }}
          className="terms-content"
          style={{ textAlign: 'left' }}
        />
      </div>
    </div>
  );
};

export default TermsAndConditions;
